// DoctorImage.js
import React, { useState } from 'react';
import '../DoctorPictures/DoctorPictures.css';
import DoctorInfoModal from '../DoctorInfoModal/DoctorInfoModal';

const DoctorImage = ({ doctorName }) => {
  const [isHovered, setIsHovered] = useState(false);

  const doctorNamesJson = {
    "doctors": [
      { 
        "Ville Ranta": "/CandidoTomas.jpg",
        "Doctor Info": "velit scelerisque in dictum non consectetur a erat nam at",
        "languageCodes": ["fi", "no"]
      },
      { 
        "Petri Nurmi": "/CandidoTomas.jpg",
        "Doctor Info": "elit ut aliquam purus sit amet luctus venenatis lectus magna",
        "languageCodes": ["fi", "en", "sv"]
      },
      { 
        "Lauri Hellevuo": "/CandidoTomas.jpg",
        "Doctor Info": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
        "languageCodes": ["fi", "en", "pt", "sv"]
      },
      { 
        "Doctor": "/CandidoTomas.jpg",
        "Doctor Info": "massa massa ultricies mi quis hendrerit dolor",
        "languageCodes": ["fi", "en"]
      },
      { 
        "Pia Allinen": "/CandidoTomas.jpg",
        "Doctor Info": "sed sed risus pretium quam vulputate dignissim",
       "languageCodes": ["fi", "en"]
      },
      { 
        "Testi Ukkeli": "/CandidoTomas.jpg",
        "Doctor Info": "accumsan lacus vel facilisis volutpat est",
        "languageCodes": ["sv", "en"]
      },
      { 
        "Lauri": "/CandidoTomas.jpg",
        "Doctor Info": "nulla aliquet porttitor lacus luctus accumsan",
        "languageCodes": ["fi", "en"]
      },
      { 
        "Mikko Haikala": "/CandidoTomas.jpg",
        "Doctor Info": "metus vulputate eu scelerisque felis imperdiet",
        "languageCodes": ["pt", "en", "fi"]
      }
      // Add more doctors as needed
    ]
  };
  
  // Find the doctor object in the array
  const doctorObject = doctorNamesJson.doctors.find(doctor => doctorName in doctor);
  
  // Retrieve doctor's path
  const picturePath = doctorObject ? doctorObject[doctorName] : undefined;

  const doctorInfo = doctorObject ? doctorObject["Doctor Info"] : undefined;

  const doctorLanguageCodes = doctorObject ? doctorObject["languageCodes"] : undefined;

  return (
    <div
      className="doctor-image"
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img src={picturePath} alt={doctorName} style={{ maxWidth: '100%', height: 'auto' }} />
      {isHovered && <div className="overlay"></div>} {/* Grey overlay */}
      {isHovered && <DoctorInfoModal infoImagePath={picturePath} doctorName={doctorName} doctorInfo={doctorInfo} languageCodes={doctorLanguageCodes}/>} {/* Pass infoImagePath to DoctorInfoModal */}
    </div>
  );
};

export default DoctorImage;

